























































import {
  ref,
  defineComponent,
  computed,
  useContext,
  watch,
} from '@nuxtjs/composition-api';
import {
  SfModal,
  SfBar,
  SfRadio,
  SfButton,
} from '@storefront-ui/vue';
import { useStore } from '~/composables';
import { useUiState } from '~/composables/useUiState';
import { useOrderCancel } from '~/modules/customer/composables/useOrderCancel';
import { useCustomerOrderStore } from '~/modules/customer/stores/customerOrder';

export default defineComponent({
  name: 'CancelOrderReasonModal',
  components: {
    SfModal,
    SfBar,
    SfRadio,
    SfButton
  },
  setup(_, { emit }) {
    const { isCancelOrderReasonModalOpen } = useUiState();
    const selectedReason = ref();
    const { orderCancel } = useOrderCancel();
    const customerOrder = useCustomerOrderStore();
    const otherReason = ref('');
    const cancelOrderReason = [
      {
        label: 'Item no longer needed',
        value: 'NOT_NEEDED',
      },
      {
        label: 'Found a better price',
        value: 'GOT_BETTER_PRODUCT',
      },
      {
        label: 'Ordered by mistake',
        value: 'MISTAKE_ORDER',
      },
      {
        label: 'Other',
        value: 'OTHER',
      }
    ];

    const cancelOrder = async () => {
      const orderNumber = customerOrder.activeOrderNumber;
      const reason = selectedReason.value === 'OTHER' ? otherReason.value : cancelOrderReason.find((reason) => reason.value === selectedReason.value).label;
      await orderCancel(orderNumber, reason);
      customerOrder.unsetActiveOrderNumber();
      emit('close');
    };

    return {
      isCancelOrderReasonModalOpen,
      cancelOrderReason,
      selectedReason,
      cancelOrder,
      otherReason
    };
  },
});
